import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'

interface StationAssignmentTableProps {
  rows: {
    id: string
    description: string
    pipe: string
    soil: string
    water_required: string
    surface_accumulation: string
    plant_water: string
    precipitation_rate: string
    expected_flow: string
    landscape: string
    program: string
    plant_group: string
    precip: string
    emitter: string
    efficiency: string
    manual_ops: string
    et_node: string
  }[]
}

const StationAssignmentTable: FC<StationAssignmentTableProps> = ({ rows }) => {
  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'common.white',
          border: '1px solid #EFEFEF',
          borderRadius: '3px',
          '&::-webkit-scrollbar': {
            width: '8px',
            height: '8px',
          },

          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#C1C1C1',
            borderRadius: '5px',
          },
        }}
      >
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ backgroundColor: '#EFEFEF' }}>
            <TableRow>

              <TableCell
                sx={{
                  minWidth: '29px',
                  borderRight: '1px solid #D7D7D7',
                  backgroundColor: '#EFEFEF',
                  position: 'sticky',
                  left: 0,
                }}
              >
                ID
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '144px',
                }}
              >
                Description
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Pipe
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Soil
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',

                }}
              >
                Water Required
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',

                }}
              >
                Surface Accumulation
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Plant Available Water
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Precipitation Rate
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Expected Flow
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Landscape Factor (%)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Program
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Plant Group
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Precip(mm/hr)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Emitter
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Efficiency
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                Manual Ops Run Time (Min)
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '115.2px',
                }}
              >
                ET-Node
              </TableCell>

            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row) => (
              <TableRow key={row.id}>

                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                    position: 'sticky',
                    left: 0,
                    backgroundColor: '#FFFFFF',
                  }}
                >
                  {row.id}
                </TableCell>
                <TableCell>{row.description}</TableCell>
                <TableCell>{row.pipe}</TableCell>
                <TableCell>{row.soil}</TableCell>
                <TableCell>{row.water_required}</TableCell>
                <TableCell>{row.surface_accumulation}</TableCell>
                <TableCell>{row.plant_water}</TableCell>
                <TableCell>{row.precipitation_rate}</TableCell>
                <TableCell>{row.expected_flow}</TableCell>
                <TableCell>{row.landscape}</TableCell>
                <TableCell>{row.program}</TableCell>
                <TableCell>{row.plant_group}</TableCell>
                <TableCell>{row.precip}</TableCell>
                <TableCell>{row.emitter}</TableCell>
                <TableCell>{row.efficiency}</TableCell>
                <TableCell>{row.manual_ops}</TableCell>
                <TableCell>{row.et_node}</TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

    </Stack>
  )
}

export default StationAssignmentTable
